declare let window: Window & {
  VITE_KEYCLOAK_URL: string;
  VITE_KEYCLOAK_REALM: string;
  VITE_KEYCLOAK_CLIENT_ID: string;
};

export default {
  url: window['VITE_KEYCLOAK_URL'] || import.meta.env.VITE_KEYCLOAK_URL,
  realm: window['VITE_KEYCLOAK_REALM'] || import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: window['VITE_KEYCLOAK_CLIENT_ID'] || import.meta.env.VITE_KEYCLOAK_CLIENT_ID
};
